export const checksNames = [
  { id: "1", name: "Desayuno" },
  { id: "2", name: "Colación" },
  { id: "3", name: "Almuerzo" },
  { id: "4", name: "Merienda" },
  { id: "5", name: "Cena" },
];

export const types_food = [
  { id: "4", name: "Apto diabéticos" },
  { id: "3", name: "Vegano" },
  { id: "6", name: "Keto" },
  { id: "2", name: "Vegetariano" },
  { id: "7", name: "Sin tacc" },
  { id: "5", name: "Saludable" },
];
